import { EnumItemModel } from './ItemModels';

export enum EReportFilterDateType {
    Custom = 1,
    QuarterToDate = 2,
    LastQuarter = 3,
    YearToDate = 4,
    LastYear = 5,
    Last12FullMonth = 6
}

export const ReportFilterDateTypeEnumItems:
    ReadonlyArray<EnumItemModel<EReportFilterDateType>> = [
        { text: 'Custom', value: EReportFilterDateType.Custom },
        { text: 'Quarter', value: EReportFilterDateType.QuarterToDate },
        { text: 'Last quarter', value: EReportFilterDateType.LastQuarter, },
        { text: 'Year', value: EReportFilterDateType.YearToDate },
        { text: 'Last year', value: EReportFilterDateType.LastYear },
        { text: 'Last 12 Months', value: EReportFilterDateType.Last12FullMonth }
    ];
